<template>
  <div>
    <ScanFormDPHead
            :countFilterParams="countFilterParams"
            :showFilter="showFilter"
            @toggleFilter="toggleFilter"
            @filter="$emit('filter')"
            @reload="$emit('reload')"
    />

    <div class="table-filter-wrap">
      <ScanFormDPFilter
              :showFilter="showFilter"
              :filterGetParams="filterGetParams"
              @close="closeFilter"
              @changeFilter="data => $emit('changeFilter', data)"
              @resetFilter="$emit('resetFilter')"
      />

      <ScanFormDPTable
          :countFilterParams="countFilterParams"
              @showMore="$emit('showMore')"
              @resetFilter="$emit('resetFilter')"
              @updateTable="$emit('updateTable')"
              @reload="$emit('reload')"
      />
    </div>
  </div>
</template>

<script>


  import ScanFormDPHead from "./ScanFormDPHead/ScanFormDPHead";
  import ScanFormDPFilter from "./ScanFormDPFilter/ScanFormDPFilter";
  import ScanFormDPTable from "./ScanFormDPTable/ScanFormDPTable";

  export default {
    name: "ScanFormDPTableAdmin",

    components: {
      ScanFormDPHead,
      ScanFormDPFilter,
      ScanFormDPTable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },
    }
  }
</script>

<style scoped>

</style>
